export const SAVINGS_TEXTS = {
    NON_EXPRESS: "Enjoy One BLCK Exclusive Benefits",
    EXPRESS: "Express Mode Activated",
    BOLT: "Enjoy lightning-fast delivery",
    _99STORE: "Enjoy free delivery with {{img|portal/static-assets/hcms/Cart_header_99_Store.png}}",
};
